import {
  SET_CHAT_THEME_SETTINGS,
  SET_CHAT_ACTIONS,
  SET_QUICKSTART_OVERLAY,
  SET_SHOW_REGISTRATION_MODAL,
  SET_OLD_TID,
  SET_REGISTRATION_MODAL_STEP,
  SET_VDP_VEHICLE_DETAILS,
  SET_MOBILE_NAVIGATION_DETAILS,
  SET_OPEN_TVM_HELP_MODAL,
  SET_OPEN_TVM_NAVIGATE_TILE,
  SET_SUBARU_OEM_PROGRAM_CODES,
  SET_MENU_SECTION_SETTINGS,
  SET_IFRAME_MODAL_POPUP_DETAILS,
  SET_OPEN_OTP_DETAILS_MODAL,
  SET_OTP_MODAL_DATA,
} from '../StoreConstants/CommonSettingsConstants';

export const CommonSettingsStore = {
  state: {
    showQuickStartup: false,
    showRegistrationModal: false,
    tvmHelpModalSettings: {},
    tvmNavigateTileSettings: {},
    chatThemeSettings: {},
    tvmChatActions: {},
    tvmOldTid: '',
    vehicleDetails: {},
    mobileNavigationDetails: [],
    getSubaruOemCodes: '',
    menuSectionSettings: [],
    iframeModalPopUpDetails: null,
    openOtpDetailsModal: false,
    otpModalData: {},
  },
  mutations: {
    [SET_QUICKSTART_OVERLAY]: (state, payload) => {
      state.showQuickStartup = payload;
    },
    [SET_OPEN_TVM_HELP_MODAL]: (state, payload) => {
      state.tvmHelpModalSettings = payload;
    },
    [SET_OPEN_TVM_NAVIGATE_TILE]: (state, payload) => {
      state.tvmNavigateTileSettings = payload;
    },
    [SET_CHAT_ACTIONS]: (state, payload) => {
      state.tvmChatActions = payload;
    },
    [SET_SHOW_REGISTRATION_MODAL]: (state, payload) => {
      state.showRegistrationModal = payload;
    },
    [SET_REGISTRATION_MODAL_STEP]: (state, payload) => {
      state.registrationModalProfileCreation = payload;
    },
    [SET_CHAT_THEME_SETTINGS]: (state, payload) => {
      state.chatThemeSettings = payload;
    },
    [SET_OLD_TID]: (state, payload) => {
      state.tvmOldTid = payload;
    },
    [SET_VDP_VEHICLE_DETAILS]: (state, payload) => {
      state.vehicleDetails = payload;
    },
    [SET_MOBILE_NAVIGATION_DETAILS]: (state, payload) => {
      state.mobileNavigationDetails = payload;
    },
    [SET_SUBARU_OEM_PROGRAM_CODES](state, payload) {
      state.getSubaruOemCodes = payload;
    },
    [SET_MENU_SECTION_SETTINGS]: (state, payload) => {
      state.menuSectionSettings = payload;
    },
    [SET_IFRAME_MODAL_POPUP_DETAILS](state, payload) {
      state.iframeModalPopUpDetails = payload;
    },
    [SET_OPEN_OTP_DETAILS_MODAL]: (state, payload) => {
      state.openOtpDetailsModal = payload;
    },
    [SET_OTP_MODAL_DATA]: (state, payload) => {
      state.otpModalData = payload;
    },
  },
};
